import commonPostTypeConfig from '../../common/postTypes/qualification'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'qualification',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
